import React from 'react'
import PropTypes from 'prop-types'
import * as S from './Marker.styled'
import { ColorConsts } from '@styles/theme-const'

const Marker = ({ borderColor, children, backgroundColor = ColorConsts.orange, color = ColorConsts.white }) => {
    return (
        <S.Marker borderColor={borderColor} color={color} backgroundColor={backgroundColor}>
            {children}
        </S.Marker>
    )
}

Marker.propTypes = {
    backgroundColor: PropTypes.string,
    borderColor: PropTypes.string,
    color: PropTypes.string,
    children: PropTypes.any
}

export default Marker
